import { useState, useEffect } from "react";
import { db } from "./firebase"; // Adjust the import based on your Firebase config location
import { doc, getDoc } from "firebase/firestore";

const ScheduleSection = () => {
  const [schedule, setSchedule] = useState(null);

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const docRef = doc(db, "schedule", "timetable");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setSchedule(docSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching schedule:", error);
      }
    };

    fetchSchedule();
  }, []);

  if (!schedule) {
    return <p>Loading schedule...</p>;
  }

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    <div className="container-schedule">
      <div className="content-wrapper-schedule">
        {/* Schedule Table */}
        <div className="card-schedule">
          <div className="table-wrapper-schedule">
            <table className="table-schedule">
              <thead>
                <tr>
                  <th className="header-schedule">Day</th>
                  <th className="header-schedule">Opening Hours</th>
                </tr>
              </thead>
              <tbody>
                {days.map((day, index) => (
                  <tr key={index}>
                    <td>{day.charAt(0).toUpperCase() + day.slice(1)}</td>
                    <td>{schedule[day] || "Closed"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="notice-schedule">{schedule.text1}</p>
            <p className="notice-schedule">{schedule.text2}</p>
          </div>
        </div>

        {/* Map Section */}
        <div className="card-schedule">
          <h2 className="map-title-schedule">STORE LOCATOR:</h2>
          <div className="map-wrapper-schedule">
            <iframe
              className="map-schedule"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2490.3002129321917!2d0.5312804759216881!3d51.3791602200645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8cd06b06ca24b%3A0xabdb4a39b60c08e3!2sRight%20Cash%20(Buy-Sell-Buybacks)!5e0!3m2!1sen!2s!4v1742423002327!5m2!1sen!2s"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* Company Info */}
        {/* <div className="card-schedule">
          <h2 className="company-name-schedule">Right Cash Ltd</h2>
          <p className="company-desc-schedule">
            Right Cash Ltd is Authorised and regulated by the
            <strong> Financial Conduct Authority</strong> for consumer credit
            activities.
          </p>
          <p className="company-desc-schedule">
            Members of the <strong>National Pawnbrokers Association</strong>
          </p>
          <p className="complaint-text-schedule">
            Have a complaint or dispute regarding our pawnbroking service?
          </p>
          <a href="#" className="complaint-link-schedule">
            CLICK HERE FOR MORE INFO
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default ScheduleSection;
